webpackJsonp([27],{

/***/ "Tcr8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/video-player_29fcaf7fefd3cb675bc5241d182a8e6d.html";

/***/ }),

/***/ "lOrt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VideoPlayer = (function () {
    VideoPlayer.$inject = ["$element", "$rootScope"];
    function VideoPlayer($element, $rootScope) {
        var _this = this;
        this.$element = $element;
        this.$rootScope = $rootScope;
        this.showPreview = true;
        this.settings = this.settings || {};
        this.videoHandlerBind = angular.noop;
        this.defaultSetting = {
            preload: true,
            muted: true,
            loop: true,
            controls: false
        };
        this.videoHandlerBind = function () { return _this.videoHandler(); };
        if (!this.video.preview)
            this.loadVideo();
    }
    VideoPlayer.prototype.$onDestroy = function () {
        this.videoEl && this.videoEl.removeEventListener('loadeddata', this.videoHandlerBind);
    };
    VideoPlayer.prototype.videoHandler = function () {
        this.showPreview = false;
        this.$rootScope.$apply();
        this.setVideoSettings();
    };
    VideoPlayer.prototype.loadVideo = function () {
        var _this = this;
        this.showVideo = true;
        setTimeout(function () {
            _this.videoEl = _this.$element[0].querySelector('video');
            _this.videoEl.addEventListener('loadeddata', _this.videoHandlerBind);
        }, 0);
    };
    VideoPlayer.prototype.triggerPlay = function () {
        this.videoEl = this.$element[0].querySelector('video');
        this.videoEl && this.videoEl.paused ? this.videoEl.play() : this.videoEl.pause();
    };
    VideoPlayer.prototype.setVideoSettings = function () {
        Object.assign(this.videoEl, this.defaultSetting, this.settings);
    };
    return VideoPlayer;
}());
exports.VideoPlayer = VideoPlayer;
angular.module('animatronApp.videoPlayer', []).component('videoPlayer', {
    bindings: {
        video: '<',
        settings: '<'
    },
    controller: VideoPlayer,
    templateUrl: __webpack_require__("Tcr8")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/27-82c0e6a2dceb23823569.min.js